import { render, staticRenderFns } from "./NotAuthModal.vue?vue&type=template&id=4c3a1a91"
import script from "./NotAuthModal.vue?vue&type=script&lang=ts"
export * from "./NotAuthModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports